<template>
    <v-container>
        <div v-if="hasPermission('MIETSPIEGEL_BACKEND_WRITE_BERECHNUNGSVORLAGE')" class="d-flex justify-left my-3">
            <v-btn v-on:click="save" outlined large color="indigo" aria-labelled-by="Speichern"><span class="black--text subtitle-1">Speichern</span></v-btn>
        </div>
        <div class="my-3">
            <h1 class="uiTitle header">
                Sanitärbereich
            </h1>
            <p class="subTitle d-flex justify-center">
                <span style="text-decoration:underline; font-size:16px">(Mehrfachnennung möglich)</span>
            </p>
        </div>
        <div class="mb-5">
            <div class="d-flex flex-column grey lighten-3 font-weight-bold errors" role="alert" v-if="sanitaerbereich">
                <div>
                    <v-icon style="color:#c50517">mdi-alert</v-icon>
                    <strong class="red--text">Konflikt!</strong>
                </div>
                <span class="red--text" v-html="getConflictTexts()"></span>
                <br/>
                <span class="red--text">Bitte ändern Sie Ihre Eingabe.</span>
            </div>
            <p class="validationError" role="alert" v-if="validationError">
                <v-icon style="color:#c50517">mdi-alert</v-icon><strong>Bitte wählen Sie eine Option aus!</strong>
            </p>
            <v-card class="d-flex justify-center"
                outlined
            >
                <v-list class="py-0" style="width:100%" role="group">
                    <v-list-item-group multiple role="list" tabindex="0" :aria-active-descendant="selectedItem" v-model="selectedItem" color="transparent" active-class="list-selected">
                        <template v-for="(item, index) in items">
                            <v-divider
                                v-if="item.divider"
                                :key="index"
                                aria-hidden="true"
                            ></v-divider>
                            <v-list-item
                                v-else
                                :key="index"
                                tabindex="-1"
                                :id="item.id"
                            >
                                <input class="d-flex justify-center" @focus="focusInputParent" type="checkbox" tabindex="-1" :checked="isSelected(item.id)" :title="$t('sanitaerbereich.' + item.id)">
                                <div class="d-flex flex-column" :style="getColor(item.id)" v-if="hasError(item.error)">
                                    <strong v-if="isSelected(item.id)">Konflikt!</strong>
                                    <strong v-else>Warnung!</strong>
                                    <v-tooltip bottom>
                                       <template v-slot:activator="{ on }">
                                            <v-icon :style="getColor(item.id)" v-on="on">mdi-alert</v-icon>
                                        </template>
                                        <span :aria-labelled-by="getErrorText(item.errorTypes, item.error, item.id)" v-html="getErrorText(item.errorTypes, item.error, item.id)"></span>
                                    </v-tooltip>
                                </div>
                                <v-list-item-content aria-hidden="true" style="color: black; margin-left: 8px">
                                    <v-list-item-title :class="(hasError(item.error) ? 'conflictGrey': '')" v-html="$t('sanitaerbereich.' + item.id)"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-list-item-group>
                </v-list>
            </v-card>
        </div>
        <!-- BUTTON SECTION -->
        <div class="d-flex justify-center justify-space-around my-3">
            <v-btn v-on:click="back" outlined large color="indigo" aria-labelled-by="Zurück"><span class="black--text subtitle-1">Zurück</span></v-btn>
            <v-btn v-on:click="next" outlined large color="indigo" aria-labelled-by="Weiter"><span class="black--text subtitle-1">Weiter</span></v-btn>
        </div>
        <!-- INFO SECTION -->
        <div>
            <v-card class="d-flex justify-center mt-6" outlined color="indigo" hover>
                <v-expansion-panels>
                    <v-expansion-panel ref="infoPanel">
                        <v-expansion-panel-header @click="changedExpansion" v-if="expanded" aria-label="Info-Bereich Schließen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-header @click="changedExpansion" v-else aria-label="Info-Bereich Öffnen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <h3>Sanitärbereich</h3><br/>
                            <h3>Besondere Zusatzausstattung im Bad vorhanden</h3><br/>
                            <p>Es muss zusätzlich zur Badewanne eine separate Dusche und ein zweites Waschbecken (beziehungsweise 
                                Doppelwaschbecken) und/oder ein Bidet vorhanden sein.
                             </p>

                             <h3>Fläche des (größten) Bades beträgt mindestens 6 m<sup>2</sup> und/oder zweites ausgestattetes Bad vorhanden</h3><br/>
                            <p>Ein ausgestattetes Bad ist ein abgeschlossener Raum der Wohnung mit mindestens einer Badewanne oder Dusche.</p>

                            <h3>Modernisiertes Bad</h3><br/>
                            <p>Wohnung in einem Gebäude mit einem Baujahr vor 1999, bei der 2019 oder später das Bad modernisiert 
                                beziehungsweise instandgesetzt wurde. Die Modernisierung beziehungsweise Instandsetzung muss 
                                mindestens Badewanne und/oder Dusche sowie Wand- und Bodenbeläge umfassen.</p>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card>
        </div>
    </v-container>
</template>

<script>
    import {Component, Vue} from 'vue-property-decorator';
    import { EventBus } from '../eventbus';
    import { mapActions, mapState, mapMutations, createNamespacedHelpers } from 'vuex';

    const { mapGetters } = createNamespacedHelpers('user')

    @Component({
        // don't get confused, this is a sanitaerbereich ERROR
        computed: { ...mapState('error', ['sanitaerbereich']),
                    ...mapState('berechnung', ['localSanitaerbereich']),
                    ...mapGetters(['hasPermission'])
        },
        methods: { ...mapActions('berechnung', ['SELECT_SANITAERBEREICH']),
                   ...mapActions('error', ['CHECK_BAUJAHR_ERROR']),
                   ...mapMutations('error', ['SET_SANITAERBEREICH_ERROR']),
                    ...mapMutations('berechnung', ['UPDATE_LOCAL_SANITAERBEREICH'])}
    })
    export default class Sanitaerbereich extends Vue {

        get error(){
            return this.selectedData.some(item => this.hasError(item.error))
        }

        get selectedData(){
            return this.items.filter(item => this.selectedItem.includes(item.id))
        }

        get selectedItem(){
            return this.localSanitaerbereich
        }

        set selectedItem(selection){
            this.UPDATE_LOCAL_SANITAERBEREICH({ selection: selection, none: this.noneOfThese })
        }

        data() {
            return {
                index: 9,
                noneOfThese: 5,
                items: [
                    { id: 0
                    },
                    { divider: true},
                    { id: 1},
                    { divider: true},
                    { id: 2},
                    { divider: true},
                    { id: 3},
                    { divider: true},
                    { id: 4,
                      error: {
                        //TODO nochmals prüfen, wenn Sanitärbereich Auswahlmöglichkeiten klar
                        selectedBaujahr: function(el){ return el > 6 }
                      },
                      errorTypes: [
                        "Baujahr"
                      ]
                    },
                    { divider: true},
                    { id: 5},
                ],
                validationError: false,
                expanded: false
            };
        }

        focusInputParent(event){
            //only triggered by screenreader
            event.target.parentElement.focus()
            event.preventDefault()
        }

        changedExpansion(event){
            this.expanded = !this.expanded
            event.currentTarget.setAttribute('aria-expanded', this.expanded)
        }

        checkForm() {
            this.validationError = false;
            if(this.selectedItem.length == 0) {
                this.validationError = true;
            }
            return !this.validationError;
        }

        isSelected(index) {
            if(this.selectedItem != null) {
                return this.selectedItem.includes(index);
            }
        }

        hasError(error){
            /*
             * check if function in error for selected attribute (of different component) matches
             * the stored value (of the different component in the state)
             */
            return error && Object.keys(error).map(key => error[key](this.$store.state.berechnung[key])).some(el => el === true)
        }

        getErrorText(errorTypes, error, id){
            /*
             * select those errorTypes (= different components), whose selected value
             * in the store is matched by the function at the same index in error (of the item)
             */
            let errorType = errorTypes.filter((_, i) => error[Object.keys(error)[i]](this.$store.state.berechnung[Object.keys(error)[i]]));
            return errorType.map(el => this.$t('warning.select',
                { step: this.$t(el),
                  choice: this.$t(el.charAt(0).toLowerCase() + el.substring(1) + '.' +
                          this.$store.state.berechnung['selected' + el]),
                  currentStep: "von ",
                  currentChoice: this.$t('sanitaerbereich.' + id)
                })).join("<br/>");
        }

        //when conflict is present its text is depending on the items in the store, not the current selection
        getConflictTexts(){
            //get those items in the store that have an error defined and show their errorTexts
            return this.items.filter(item => this.$store.state.berechnung.selectedSanitaerbereich.includes(item.id) && item.error)
                                .map(conflictItem => {
                                    return this.getErrorText(conflictItem.errorTypes, conflictItem.error, conflictItem.id)
                                })
                                .reduce((acc, curr) => acc + '<br/>' + curr)
        }

        mounted() {
            EventBus.$emit('scroll', this.$data.index)
            this.$refs.infoPanel.$el.firstChild.setAttribute('aria-expanded', false)
            var vm = this;
            const listgroup = document.querySelector('[role="group"]').firstChild
            listgroup.addEventListener('focus', event => {
                event.target.firstChild.focus()
            })
            //item group handling: (un)select on spacebar
            listgroup.addEventListener('keydown', event => this.multiItemSelection(event, vm))
        }

        multiItemSelection(event, vm){
            if(event.key !== ' ') return
            const option = event.target.closest('.v-list-item')
            if (!option) return
            const id = parseInt(option.id)
            if(vm.selectedItem.includes(id)){
                setTimeout(function(){
                    let selection = vm.selectedItem.slice()
                    selection.splice(selection.indexOf(id), 1)
                    vm.selectedItem = selection
                }, 100)
            }else{
                setTimeout(function(){
                    let selection = vm.selectedItem.slice()
                    selection.push(id)
                    vm.selectedItem = selection
                }, 100)
            }
            event.preventDefault()
        }

        save() {
            EventBus.$emit('getSaveData', this.index)
        }

        next() {
            if(this.checkForm()) {
                console.log(this.selectedItem)
                this.SELECT_SANITAERBEREICH({ selectedSanitaerbereich: this.selectedItem,
                                              selectedSanitaerbereichError: this.selectedData
                                                                                .filter(it => it.error)
                                                                                .map(item => item.error) })
                this.CHECK_BAUJAHR_ERROR()
                if(this.error){
                    console.log('found sanitaerbereich error')
                    this.SET_SANITAERBEREICH_ERROR(true)
                    let alert = document.querySelector('.errors')
                    alert.removeAttribute('role')
                    alert.setAttribute("role", "alert")
                } else {
                    this.SET_SANITAERBEREICH_ERROR(false)
                    this.$router.push('kueche')
                }
            }else{
                let alert = document.querySelector('.validationError')
                alert.removeAttribute('role')
                alert.setAttribute("role", "alert")
            }
        }

        back() {
            this.$router.push('fussbodenheizung')
        }

        getColor(index){
            if(this.isSelected(index)){
                return "color:#c50517";
            }
            return "color:blue";
        }
    }
</script>
